import { FaTwitter, FaFacebook, FaInstagram, FaYoutube } from "react-icons/fa";

export const footerItems = {
  companyName: "Bizcoverindia",
  companyDescription:
    "Bizcoverindia.com online B2B marketplace is India's leading platform, connecting international buyers with Indian suppliers. Our platform caters to Small & Medium Enterprises (SMEs), Large Enterprises, and individuals, providing a convenient way to conduct business. Our mission is to simplify the process of doing business by offering a wider marketplace with a variety of products and suppliers, enhancing business visibility, boosting brand credibility, and providing a reliable Lead Management System. Connect with sellers anytime, anywhere and join our global value chain to interact and transact securely and effectively.",
  sections: [
    {
      title: "Marketplace",
      links: [
        { label: "Home", href: "/" },
        { label: "All Products", href: "/search" },
        { label: "Shops", href: "/sellers" },
        { label: "Pricing", href: "/pricing" },
      ],
    },
    {
      title: "For business",
      links: [
        { label: "Become a Seller", href: "/login?tab=signup" },
        { label: "Login to Seller Panel", href: "/login?tab=signin" },
        { label: "Order History", href: "/buyer/orders" },
        { label: "My Wishlist", href: "/buyer/favorites" },
      ],
    },
    {
      title: "Support",
      links: [
        {
          label: "Email support",
          href: "mailto:support@bizcoverindia.com",
        },
        {
          label: "Call us",
          href: "tel:+919894399054",
        },
        { label: "Terms & Conditions", href: "/terms" },
        { label: "Privacy Policy", href: "/privacy" },
        { label: "Return Policy", href: "/return-policy" },
      ],
    },
  ],
  socialLinks: [
    { icon: FaTwitter, href: "https://x.com/bizcoverindia", label: "Twitter" },
    { icon: FaFacebook, href: "https://www.facebook.com/bizcoverindia.b2b", label: "Facebook" },
    { icon: FaYoutube, href: "https://www.youtube.com/bizcoverindia", label: "YouTube" },
    { icon: FaInstagram, href: "https://www.instagram.com/bizcoverindia", label: "Instagram" },
  ],
  contactInfo: {
    phone: "+91 98943 99054, +91 85249 22323",
    email: "support@bizcoverindia.com",
    address: "Bizcoverindia, India",
  },
  copyrightText: "© 2026 Bizcoverindia Platform. All rights reserved.",
};
